/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createReducer, on } from '@ngrx/store';

import { DiscountCode } from '@core/models';
import { DiscountCodeActions } from '../actions';
export const DISCOUNT_CODE_FEATURE_KEY = 'discountCodes';

export interface DiscountCodeState {
  discountCodes: DiscountCode[];
  discountCodesCount: number;
  loading: boolean;
}

const initialState: DiscountCodeState = {
  discountCodes: null,
  discountCodesCount: null,
  loading: false,
} as any;

export const discountCodesReducer = createReducer(
  initialState,
  on(
    DiscountCodeActions.loadDiscountCodes,
    DiscountCodeActions.createDiscountCode,
    DiscountCodeActions.updateDiscountCode,
    DiscountCodeActions.deleteDiscountCode,
    (state) => ({
      ...state,
      loading: true,
    })
  ),
  on(DiscountCodeActions.loadDiscountCodesSuccess, (state, { discountCodes }) => ({
    ...state,
    discountCodes,
    loading: false,
  })),
  on(DiscountCodeActions.loadDiscountCodeByIdSuccess, (state, { discountCode }) => ({
    ...state,
    discountCodes: [...(state.discountCodes || []), discountCode],
    loading: false,
  })),
  on(DiscountCodeActions.loadDiscountCodesCountSuccess, (state, { discountCodesCount }) => ({
    ...state,
    discountCodesCount,
  })),
  on(DiscountCodeActions.createDiscountCodeSuccess, (state, { discountCode }) => ({
    ...state,
    discountCodes: [discountCode, ...(state.discountCodes || [])],
    discountCodesCount: state.discountCodesCount + 1,
    loading: false,
  })),
  on(DiscountCodeActions.updateDiscountCodeSuccess, (state, { discountCode }) => ({
    ...state,
    discountCodes: state.discountCodes?.map((code) => (code.id === discountCode.id ? discountCode : code)),
    loading: false,
  })),
  on(DiscountCodeActions.deleteDiscountCodeSuccess, (state, { id }) => ({
    ...state,
    discountCodes: state.discountCodes.filter((code) => code.id !== id),
    discountCodesCount: state.discountCodesCount - 1,
    loading: false,
  })),
  on(
    DiscountCodeActions.loadDiscountCodesFailure,
    DiscountCodeActions.createDiscountCodeFailure,
    DiscountCodeActions.updateDiscountCodeFailure,
    DiscountCodeActions.deleteDiscountCodeFailure,
    DiscountCodeActions.loadDiscountCodesCountFailure,
    (state) => ({
      ...state,
      loading: false,
    })
  )
);
